import React, { useEffect, useState } from "react";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import { useForm } from "react-hook-form";
import { Modal } from "../../share/modal/Modal";
import DragAndDrop from "../../share/dragAndDropFile/DragAndDrop";
import useFetch from "../../../Hooks/useFetch";
import Cookies from "js-cookie";
import { BtnPrimary } from "../../share/buttons/Btn";

function Profile(close) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const [data, setData] = useState({
        initiator_profile_name: "",
        initiator_profile_phone_number: "",
        initiator_profile_email: "",
        initiator_profile_resume: "",
        id: "",
    });

    const [name, setName] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [email, setEmail] = useState();
    const [call, setCall] = useState();
    const [file, setFile] = useState();
    const [upload, setUpload] = useState(false);

    const handleModal = () => {
        setUpload((perv) => !perv);
    };
    const submitForm = () => {
        const formData = new FormData();

        formData.append("initiator_profile_name", name);
        formData.append("initiator_profile_phone_number", phoneNumber);
        formData.append("initiator_profile_email", email);
        formData.append("initiator_profile_resume", file[0]);

        setCall(formData);
        editProfile.reFetch();
    };

    const getProfile = useFetch({
        method: "GET",
        url: `InitiatorProfileRollService/${Cookies.get("adminId")}`,
        noHeader: false,
        trigger: true,
        setter: setData,
    });
    const editProfile = useFetch({
        method: "PATCH",
        url: `InitiatorProfileRollService/${Cookies.get("adminId")}`,
        noHeader: false,
        data: call,
        trigger: false,
        caller: getProfile,
    });
    const deleteProfile = useFetch({
        method: "DELETE",
        url: `InitiatorProfileRollService/${Cookies.get("adminId")}`,
        noHeader: false,
        data: call,
        trigger: false,
        caller: getProfile,
    });

    useEffect(() => {
        setName(data.initiator_profile_name);
        setEmail(data.initiator_profile_email);
        setPhoneNumber(data.initiator_profile_phone_number);
    }, [data]);
    // useEffect(() => {
    //     // if (typeof name === "string") console.log(name, email, phoneNumber);
    //     console.log(typeof phoneNumber);
    // }, [name]);

    return (
        <div className="bg-white-dark pt-20 px-28 pb-80 rounded-16">
            <div
                onClick={() => handleModal()}
                className="w-1/2 py-[20px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
            >
                <span className="text-gray">آپلود پروفایل</span>
                <Upload />
            </div>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    value={name}
                    type="text"
                    name="firstName"
                    // full={true}
                    control={control}
                    placeholder="نام"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem] mt-16"
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Phone Number",
                        },
                    }}
                    value={phoneNumber}
                    type="tel"
                    name="phoneNumber"
                    full={true}
                    control={control}
                    placeholder="تلفن همراه"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem]"
                    onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Email",
                        },
                    }}
                    type="email"
                    name="email"
                    full={true}
                    control={control}
                    placeholder="ایمیل"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem]"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <BtnPrimary text="ثبت" type="submit" className="px-20 py-6" />
            </form>
            {/* <BtnPrimary text="ثبت" type="submit" className="px-20 py-6" onClick={}/> */}

            <Modal show={upload} closeModal={handleModal}>
                <DragAndDrop
                    setFile={setFile}
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    error={errors["photo"]}
                    accept=".png , .jpg"
                    type="image"
                />
            </Modal>
        </div>
    );
}

export default Profile;
